export enum SearchType {
  PEOPLE = 1,
  COUNTRY = 2,
  KEYWORD = 3,
  CATEGORY = 4,
}
